import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '../../contexts/I18nContext';
import './PaymentSuccess.scss';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { t } = useI18n();

  const handleContinue = () => {
    navigate('/dashboard');
  };

  return (
    <div className="payment-success-container">
      <div className="payment-success-card">
        <div className="success-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" fill="#4CAF50"/>
            <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h1>{t('payment.success.title', 'Payment Successful!')}</h1>
        <p>{t('payment.success.message', 'Thank you for your subscription. Your payment has been processed successfully.')}</p>
        <p>{t('payment.success.description', 'You can now enjoy all the premium features of Catoo.')}</p>
        <button className="continue-button" onClick={handleContinue}>
          {t('payment.success.continue', 'Continue to Dashboard')}
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;